import DapDSPopup from './popup.component'

export * from './popup.component'
export default DapDSPopup

DapDSPopup.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-popup': DapDSPopup
  }
}
